import LazyLoad from '@slickdeals/blueprint-twig/javascript/core/lazyLoad';
import '@slickdeals/blueprint-twig/javascript/patterns/breadcrumbs';
import '@slickdeals/blueprint-twig/javascript/components/unorderedList';
import '@slickdeals/blueprint-twig/javascript/components/button';
import '@slickdeals/blueprint-twig/javascript/components/icon';
import '@slickdeals/blueprint-twig/javascript/components/figure';
import '@slickdeals/blueprint-twig/javascript/components/panel';
import '@slickdeals/blueprint-twig/javascript/components/listPicker';
import '../patterns/adBlock';
import '../patterns/blueberryAnythingCard';
import '../patterns/blueberryDealAlertCard';
import '../patterns/blueberryDealCard';
import '../patterns/dealAlertButton';
import '../patterns/paginatedGrid';
import '../patterns/filterGrid';
import '../patterns/readMoreButton';
import '../patterns/facetedFilters';
import '../patterns/reasonToBelieveModule';
import '../patterns/dealSortListPicker';
import '../patterns/categoryIconCarousel';
import '../patterns/emptyCategory';
import '../patterns/inlineResponse';
import '../layouts/blueberry';
import '../../scss/pages/categoryPage.scss';
import { initPage } from '../utilities/initPage';
import { initInclickTracking, } from '../utilities/eventTracking';
import { inclickSources } from '../utilities/inclickSources';
import readyState from 'ready-state';
new LazyLoad(); // eslint-disable-line no-new
initPage();
const getCategoryDealData = (card, link) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const uniqueId = ((_a = new URL(link.href, window.location.origin).pathname.match(/^\/[fe]\/(\d+)/)) === null || _a === void 0 ? void 0 : _a[1]) || '';
    if (!uniqueId) {
        return null;
    }
    return {
        uniqueId,
        dealTitle: ((_c = (_b = card.querySelector('.bp-c-card_title')) === null || _b === void 0 ? void 0 : _b.textContent) === null || _c === void 0 ? void 0 : _c.trim()) || '',
        isExpired: card.getAttribute('data-label-expired') === '1',
        listPriceText: ((_e = (_d = card.querySelector('.bp-p-dealCard_originalPrice')) === null || _d === void 0 ? void 0 : _d.textContent) === null || _e === void 0 ? void 0 : _e.trim()) ||
            '',
        finalPriceText: ((_g = (_f = card.querySelector('.bp-p-dealCard_price')) === null || _f === void 0 ? void 0 : _f.textContent) === null || _g === void 0 ? void 0 : _g.trim()) || '',
    };
};
const getCategoryDealActionSource = (link) => {
    if (link.classList.contains('bp-c-card_imageContainer')) {
        return inclickSources.DEAL_IMAGE;
    }
    if (link.classList.contains('bp-c-card_title')) {
        return inclickSources.DEAL_TITLE;
    }
    if (link.classList.contains('bp-p-blueberryDealCard_comments')) {
        return inclickSources.DEAL_COMMENTS;
    }
};
readyState.domready.then(() => {
    var _a, _b;
    const heading = ((_b = (_a = document
        .querySelector('h1.bp-c-heading1')) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || 'Category Page';
    initInclickTracking(document.body, '.bp-p-dealCard', {
        containerName: heading,
        containerType: 'feed',
        getDealData: getCategoryDealData,
        getActionSource: getCategoryDealActionSource,
    });
});
